const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_graphql") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: -0.43,
    y: 12.534,
    width: 22.901,
    height: 1.187,
    transform: "translate(-5.858 16.107) rotate(-59.999)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.545,
    y: 21.162,
    width: 22.902,
    height: 1.187,
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.43,
    y: 18.008,
    width: 1.187,
    height: 13.227,
    transform: "translate(-15.812 21.857) rotate(-59.999)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.381,
    y: 0.771,
    width: 1.187,
    height: 13.227,
    transform: "translate(4.092 21.856) rotate(-59.999)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.412,
    y: 6.787,
    width: 13.227,
    height: 1.187,
    transform: "translate(-2.213 6.502) rotate(-30.001)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.389,
    y: 1.677,
    width: 1.187,
    height: 22.901,
    transform: "translate(-3.753 12.25) rotate(-30.001)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.454,
    y: 9.386,
    width: 1.187,
    height: 13.228,
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.36,
    y: 9.386,
    width: 1.187,
    height: 13.228,
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.222,
    y: 24.097,
    width: 11.504,
    height: 1.037,
    transform: "translate(-9.498 13.785) rotate(-30.001)",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12,23a2.5,2.5,0,1,1-.915-3.411A2.5,2.5,0,0,1,28.12,23",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,11.5a2.5,2.5,0,1,1-.915-3.411A2.5,2.5,0,0,1,8.2,11.5",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88,23a2.5,2.5,0,1,1,3.411.915A2.5,2.5,0,0,1,3.88,23",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,11.5a2.5,2.5,0,1,1,3.411.915A2.5,2.5,0,0,1,23.8,11.5",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,30a2.5,2.5,0,1,1,2.5-2.5A2.493,2.493,0,0,1,16,30",
    style: {
      fill: "#e10098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6.991a2.5,2.5,0,1,1,2.5-2.5,2.493,2.493,0,0,1-2.5,2.5",
    style: {
      fill: "#e10098"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.411dfe575391761bc9d9348c62a2be2a.svg";
export { ForwardRef as ReactComponent };